/* eslint-disable jira/filename-case */
import {
	createLayout,
	type Layout,
} from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';

const rightSidebars = () => [];

export const globalLayout: Layout = createLayout({
	rightSidebars: rightSidebars(),
});
